import $ from 'jquery';
import React from 'react';

import * as benchlingUtil from 'BenchlingUtil';
import * as browser from 'lib/Browser';
import ProtocolPage from 'notebook/protocols/ProtocolPage';
import ProtocolStore from 'notebook/protocols/stores/ProtocolStore';
import {Route} from 'notebook/protocols/Types';
import StepByStepPage from 'notebook/protocols/viewer/StepByStepPage';
import EntityStore from 'stores/EntityStore';
import * as net from 'util/Net';
import {ElementMouseEvent, NavLink} from 'util/Types';

interface HeaderProps {
  navLinks: Array<NavLink>;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  user?: any;
}

class Header extends React.Component<HeaderProps> {
  handleClick = (e: ElementMouseEvent): void => {
    const url = $(e.currentTarget).attr('href');
    if (url.indexOf('/protocols/') !== 0) {
      return;
    }
    benchlingUtil.navigate(e);
  };

  render(): JSX.Element {
    let item;
    const dropdownLinks = (() => {
      const result = [];
      for (item of Array.from(this.props.navLinks)) {
        if ((item as {divider: boolean}).divider) {
          result.push(<li className="divider" />);
        } else {
          const navLink = item as {text: string; href: string; method?: string};
          result.push(
            <li>
              <a href={navLink.href} onClick={this.handleClick} data-method={navLink.method}>
                {navLink.text}
              </a>
            </li>
          );
        }
      }
      return result;
    })();

    return (
      <div className="container">
        <div className="row">
          <div className="col-xs-12">
            {this.props.user != null
              ? [
                  // Signed in.
                  <div key="header-dropdown" className="user-dropdown pull-right dropdown">
                    <a className="user-img dropdown-toggle" data-toggle="dropdown">
                      <img src={this.props.user.avatar_url} height={32} width={32} />
                    </a>
                    <ul className="dropdown-menu">{Array.from(dropdownLinks)}</ul>
                  </div>,
                ]
              : (() => {
                  const result1 = [];
                  for (item of Array.from(this.props.navLinks)) {
                    const navLink = item as {text: string; href: string; method?: string};
                    result1.push(
                      <a className="anon-nav-link" href={navLink.href} onClick={this.handleClick}>
                        {navLink.text}
                      </a>
                    );
                  }
                  return result1;
                })()}
            <a href="/" onClick={this.handleClick} id="logo">
              <img className="logo" src="/static/img/navy_wordmark_500.png" />
            </a>
          </div>
        </div>
      </div>
    );
  }
}

interface Props {
  navLinks: Array<NavLink>;
  route: Route;
  params: {
    apiIdentifier: string;
    vanity: string;
  };
}

interface State {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  user?: any;
}

export default class MainPage extends React.Component<Props, State> {
  state: State = {
    user: EntityStore.currentUser(),
  };

  _updateTitle = (): void => {
    let title = 'Protocols';
    switch (this.props.route) {
      case 'protocol': {
        const {protocol} = ProtocolStore.getState();
        if (protocol != null) {
          title = protocol.name;
        }
        break;
      }
      case 'edit': {
        const {protocol} = ProtocolStore.getState();
        if (protocol != null) {
          title = `Edit ${protocol.name}`;
        }
        break;
      }
      default:
        break;
    }
    benchlingUtil.setWindowTitle(title);
  };

  componentDidMount(): void {
    let ajaxAnimationFrame: number | null = null;

    if (browser.isBrowser) {
      net.events.on(
        'ajaxStart',
        () => {
          const $strip = $('.strip');
          $strip.addClass('ajax-inprogress');

          let start: DOMHighResTimeStamp | null = null;

          function increment(timestamp: DOMHighResTimeStamp): number | undefined {
            let widthPercent;
            if (!start) {
              start = timestamp;
            }
            const steps = (timestamp - start) / 40;
            if (steps <= 14) {
              widthPercent = 1 + steps * 5;
            } else {
              widthPercent = 71 + 29 * (1 - Math.pow(0.9, steps - 14));
            }
            $strip.css({width: `${widthPercent}%`});

            if (widthPercent < 99) {
              // eslint-disable-next-line no-return-assign
              return (ajaxAnimationFrame = requestAnimationFrame(increment));
            }
            return undefined;
          }

          ajaxAnimationFrame = requestAnimationFrame(increment);
        },
        this
      );

      return net.events.on(
        'ajaxStop',
        () => {
          const $strip = $('.strip');
          if (ajaxAnimationFrame) {
            cancelAnimationFrame(ajaxAnimationFrame);
          }
          $strip.css({width: '100%'});
          $strip.removeClass('ajax-inprogress');
        },
        this
      );
    }
    EntityStore.addChangeListener(this._userChangeHandler);
    ProtocolStore.addChangeListener(this._updateTitle);
  }

  componentDidUpdate(): void {
    this._updateTitle();
  }

  _userChangeHandler = (): void => {
    this.setState({user: EntityStore.currentUser()});
  };

  componentWillUnmount(): void {
    ProtocolStore.removeChangeListener(this._updateTitle);
    EntityStore.removeChangeListener(this._userChangeHandler);
    return net.events.off(null, null, this);
  }

  render(): JSX.Element {
    const props = {key: 'main', user: this.state.user, ...this.props.params};
    const view = (() => {
      switch (this.props.route) {
        case 'protocol':
          return <ProtocolPage {...props} />;
        case 'stepbystep':
          return <StepByStepPage {...props} />;
        default:
          return null;
      }
    })();

    const header = <Header key="header" navLinks={this.props.navLinks} user={this.state.user} />;
    if (view != null) {
      return (
        // Hide header for SBS.
        <div>
          {this.props.route !== 'stepbystep' ? header : undefined}
          {view}
        </div>
      );
    }

    return <div>{header}</div>;
  }
}
